import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Swiper, SwiperSlide } from 'swiper/react'

export const VideosSwiperList = ({
  id,
  mainVideoUrl,
  replaceMainVideo,
  videos,
  swiperSettings,
}) => (
  <div className="video-list-swiper">
    <Swiper {...swiperSettings}>
      {(videos || []).map(video => (
        <SwiperSlide key={video?.id}>
          <div
            className={`video-list-swiper-thumb ${mainVideoUrl === video?.videoUrl ? 'active' : ''}`}
            onClick={() => {
              replaceMainVideo(video)
            }}
            aria-hidden
          >
            <div className="video-list-swiper-thumb-wrap">
              <img alt="" src={video.thumbnailUrl} />
            </div>
          </div>
        </SwiperSlide>
      ))}
      <button
        type="button"
        className={`${id} swiper-video-arrow swiper-video-arrow-prev`}
      >
        <FontAwesomeIcon icon={['fas', 'chevron-left']} />
      </button>
      <button
        type="button"
        className={`${id} swiper-video-arrow swiper-video-arrow-next`}
      >
        <FontAwesomeIcon icon={['fas', 'chevron-right']} />
      </button>
    </Swiper>
  </div>
)
